<template>
  <div class="checkbox-list" v-show="isOpened">
    <div
      class="checkbox-item main-checkbox"
      v-if="hasAllOption"
      @click.stop="selectAll"
    >
      <label>All</label>
      <input class="checkbox" type="checkbox" :checked="allChecked" />
    </div>
    <div
      class="checkbox-item"
      v-for="(option, index) in options"
      :key="index"
      @click.stop="check(option)"
    >
      <label>{{ option.label ? option.label : option.name }}</label>
      <input class="checkbox" type="checkbox" :checked="option.checked" />
    </div>
  </div>
</template>

<script>
export default {
  name: "CheckboxList",
  methods: {
    check(option) {
      console.log(this.field)
      this.$emit("selectItem", {
        field: this.field,
        option: option.name,
      });
    },

    selectAll() {
      this.$emit("selectAll", {
        field: this.field,
        checked: this.allChecked,
      });
    },
  },
  computed: {
    allChecked() {
      return (
        this.options.find((option) => {
          return option.checked === false;
        }) == null
      );
    },

    isOpened() {
      return this.openedPicker === this.field
    }
  },
  props: {
    options: {
      type: Array,
    },
    hasAllOption: {
      type: Boolean,
    },
    field: {
      type: String,
    },
    openedPicker: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
  #app {
    .checkbox-list {
      position: absolute;
      width: 185px;
      left: 0;
      display: flex;
      flex-direction: column;
      top: 30px;
      z-index: 2;
      background: white;
      padding: 24px; 
      background: #FFFFFF;
      /* basic */

      box-shadow: 0px 9px 18px rgba(40, 42, 48, 0.2);
      border-radius: 8px;

      .checkbox-item {
        display: flex;
        flex-direction: row-reverse;
        align-items: center;
        justify-content: flex-end;
        margin: 2px;
        cursor: pointer;

        label {
          margin: 0 10px;
          font-size: 16px;
          line-height: 130%;
          color: #26262C;
          text-transform: capitalize;
          cursor: pointer;

        }
        .checkbox {
          width: 16px;
          height: 16px;
          cursor: pointer;

        }
      }
    }
  }
</style>